import { useContext } from "react";
import PaymentMethodsContext from "../context/PaymentMethods"

export const usePaymentMethodsContext = () => useContext(PaymentMethodsContext);